import React from "react";
import ProductListItem from "../ProductListItem";
import { listItemDragProps } from "utils/drag";
import { Draggable } from "react-beautiful-dnd";

const DraggableProductCollectionItem = (props) => (
  <Draggable
    isDragDisabled={props.dragDisabled}
    key={`${props.uid}-${props.index}`}
    draggableId={props.uid}
    index={props.index}
  >
    {(provided, snapshot) => (
      <li {...listItemDragProps(provided)}>
        <ProductListItem {...props} draggable snapshot={snapshot} />
      </li>
    )}
  </Draggable>
);

export default DraggableProductCollectionItem;
